import { gsap } from 'gsap';
const id = 'backdrop'
if (!$(`#${id}`).length) {
  $('body').append($(`
  <div id="${id}"></div>
  <style>
    #${id} {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      opacity: 0;
      visibility: hidden;
      background-color: rgba(15,15,15, 0.5);
      transition: opacity .1s, visibility .1s;
      z-index: 20;
    }
  </style>
  `));
}


const showBackdrop = function () {
  gsap.to(`#${id}`, { autoAlpha: 1, duration: .1 });
}

const hideBackdrop = function () {
  gsap.to(`#${id}`, { autoAlpha: 0, duration: .1 });

  const langSwitcherModal = document.querySelector('.lang-switcher__modal.open');
  if (langSwitcherModal) {
    langSwitcherModal.classList.remove('open');
  }

  const countrySwitcherModal = document.querySelector('.country-switcher__modal.open');
  if (countrySwitcherModal) {
    countrySwitcherModal.classList.remove('open');
  }

  const splittedBannerCarousel = document.querySelector('.splitted-banner__carousel.open');
  if (splittedBannerCarousel) {
    splittedBannerCarousel.classList.remove('open');
  }
}

$(`#${id}`).on('click', hideBackdrop);

export {
  showBackdrop,
  hideBackdrop
}
